import React, { useEffect, useState } from "react"

import { blockPage, unblockPage } from "~/containers/RunnApp"

import LoadingModal from "./LoadingModal"

const LoadingSeedDataModal = () => {
  const [showModal, setShowModal] = useState(false)
  const [modalText, setModalText] = useState(
    "Loading your personalised demo...",
  )

  useEffect(() => {
    // @ts-ignore
    App.workers_status = App.cable.subscriptions.create(
      {
        channel: "LoadingDataChannel",
      },
      {
        connected: () => {
          // Connection opened
        },
        received: (data) => {
          if (data.message) {
            setModalText(data.message)
          }
          blockPage()
          setShowModal(true)
        },
      },
    )

    return () => {
      // Unsubscribe on cleanup
      // @ts-ignore
      App.workers_status.unsubscribe()
      unblockPage()
    }
  }, [])

  return <LoadingModal showModal={showModal} modalText={modalText} />
}

export default LoadingSeedDataModal
